rawTemplate